import React from "react";
import { Link } from "react-router-dom";
import styles from "../../../../styles/pages/articles/ArticleHome.module.scss";

export default function ArticleHeader({
  brand = "NexHer",
  active = "articles", 
  query = "",
  onQueryChange,
  onToggleTheme,
  showSearch = true,
}) {
  return (
    <header className={styles.header}>
      <div className={`${styles.container} ${styles.nav}`}>
        <Link to="/article" className={styles.brand} aria-label="Back to Articles home">
          <span className={styles.logo} aria-hidden="true" />
          <span>
            {brand}
            <span className={styles.muted}>.Articles</span>
          </span>
        </Link>

        <nav className={styles.navCenter} aria-label="Primary">
          <Link
            className={`${styles.chip} ${active === "articles" ? styles.chipCurrent : ""}`}
            to="/article"
          >
            Articles
          </Link>

          {/* Change these routes later if you create pages */}
          <button
            type="button"
            className={`${styles.chip} ${active === "activities" ? styles.chipCurrent : ""}`}
            aria-pressed={active === "activities"}
            style={{ cursor: "pointer" }}
          >
            Activities
          </button>

          <button
            type="button"
            className={`${styles.chip} ${active === "research" ? styles.chipCurrent : ""}`}
            aria-pressed={active === "research"}
            style={{ cursor: "pointer" }}
          >
            Research
          </button>
        </nav>

        <div className={styles.navRight}>
          {showSearch ? (
            <label className={styles.search} aria-label="Search articles">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                  d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                />
              </svg>

              <input
                type="search"
                placeholder="Search by title, tags, summary…"
                value={query}
                onChange={(e) => onQueryChange?.(e.target.value)}
                autoComplete="off"
              />
            </label>
          ) : (
            <div />
          )}

          <button
            className={styles.btnGhost}
            onClick={onToggleTheme}
            title="Toggle theme"
            aria-label="Toggle theme"
            type="button"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 3v2m0 14v2M21 12h-2M5 12H3m13.95 6.36.7.7M5.35 5.34l.7.71m12.6 0-.7.7M6.05 18.36l-.7.7M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
